<template>
  <main class="mt-3">
    <div class="container">
      <h2 class="text-center"><u>공지/이벤트 등록</u></h2>
      <div class="mb-3 row">
        <label class="col-md-3 col-form-label">분류/제목<span class="text-danger">*</span></label>
        <div class="col-md-9">
          <div class="input-group">
            <select class="form-select form-select-sm text-primary" aria-label=".form-select-sm" ref="sel_ctCd" v-model="ctCd">
              <option value="">공지카테고리선택</option>
              <option value="NT">공지</option>
              <option value="EV">이벤트</option>
              <option value="TR">여행관련</option>
              <option value="MO">항공선박</option>
              <option value="PR">홍보/안내</option>
            </select>          
            <input type="text" class="form-control w-75" ref="txt_nTitle" v-model="nTitle">
          </div>
          <!-- <div class="mt-3 mb-3 row" v-if="ctCd == 'EV' || ctCd == 'PR'">
            <div class="col-md-9">
              <span class="mb-2 fw-bold">
                ※ 이벤트와 홍보는 게시기간을 지정합니다&nbsp;&nbsp;(미지정 시, 상시노출됩니다)
              </span>
              <div class="input-group mb-3">
                <span class="input-group-text" id="basic-addon1">개시</span>
                <input type="date" class="form-control" v-model="nFrom" ref="txt_fromDate">
                <span class="input-group-text" id="basic-addon1">종료</span>
                <input type="date" class="form-control" v-model="nTo" ref="txt_toDate">
              </div>
            </div>
          </div> -->
        </div>
      </div>
      
      <hr>
      
      <div class="mb-3 row">
        <label class="col-md-3 col-form-label">
          Thumbnail 이미지 사용&nbsp;
          <span style="display: inline-flex; align-items: left;">
            <input class="form-check-input" type="checkbox" true-value="Y" false-value="N" v-model="thFlag" ref="dType" @change="checkThumb(thFlag)">
          </span>

          <!-- <br><span style="font-weight: normal; color: gray;">※팝업 시, 이미지로도 사용됨</span> -->
        </label>
        <div class="col-md-9">
          <div class="col-md-9">
            <input type="file" class="form-control" id="fileSelectorImage" accept="image/jpeg">
            <div class="alert alert-secondary" role="alert" style="font-size: 1rem;">
              <div class="text-danger fw-bold">- File 종횡비: 1:1</div>
              <div>- File 확장자: jpg</div>
              <div>- File 크기&nbsp;&nbsp;&nbsp;&nbsp;: 3메가 이하</div>
            </div>
          </div>
        </div>
      </div>
      
      <hr>

      <div class="mb-3 row">
        <label class="col-md-3 col-form-label">공지내용<span class="text-danger">*</span></label>
        <div class="col-md-9">
          <!-- QuillEditor호출 -->
          <div>
            <quill-editor v-model:content="content" :options="editorOption" @saveDocument="handleSaveDocument" />
          </div>
        </div>
      </div>

      <div class="mb-3 row">
        <div class="col-auto d-grid p-1">
          <button type="button" class="btn btn-lg btn-danger" @click="goToList">공지리스트</button>
        </div>
      </div>
    </div>
  </main>

</template>

<script>
import QuillEditor from '@/components/QuillEditor.vue'
//import axios from 'axios'

export default {
  components: { QuillEditor },

  data() {
    return {
      nTitle: "",
      nFrom: null,
      nTo: null,
      // insDate: "",
      insId: "",
      nUseFlag: "N",             //공지상태 default: 비공지
      ctCd: "",                  //공지(NT), 이벤트(EV)
      noticeCode: "",            //공지코드
      fixedFlag: "N",            //고정공지여부
      pFrom: null,               //팝업개시일
      pTo: null,                 //팝업종료일
      //popupFlag: "N",            //팝업공지여부

      // QuillEditor관련
      quillFlag: "Y",    // Quill Editor 사용여부
      //filename: "",      // 저장할 공지사항내용(공지코드.md)
      content: "",
      editorOption: {
        placeholder: '공지내용을 입력해주세요...',
        modules: {
          toolbar: 
          {
            container: [
              ['bold','italic','underline','strike'],
              ['blockquote','code-block'],
              [{ header: 1 }, { header: 2 }],
              [{ list: 'ordered' }, { list: 'bullet' }],
              [{ script: 'sub' }, { script: 'super' }],
              [{ indent: '-1' }, { indent: '+1' }],
              [{ direction: 'rtl' }],
              [{ size: ['small', false, 'large', 'huge'] }],
              [{ header: [1,2,3,4,5,6,false] }],
              [{ color: [] }, { background: [] }],
              [{ font: [] }],
              [{ align: [] }],
              ['clean'],
              ['link','image','video'],
              [{ 'imageLink': [] }], // 커스텀 툴 추가 (아래에서 핸들러 연결)
            ],
            handlers: {
              imageLink: function() {       //arrow function 사용금지(바인딩이 깨짐)
                // this는 quill 인스턴스!
                const range = this.quill.getSelection();
                if (range) 
                {
                  const [leaf] = this.quill.getLeaf(range.index);
                  if (leaf && leaf.domNode.tagName === 'IMG') 
                  {
                    const url = window.prompt('이미지에 하이퍼링크(URL)을 입력하세요:');
                    if (url) 
                    {
                      const imgNode = leaf.domNode;
                      const parent = imgNode.parentNode;
                      if (parent.tagName !== 'A') 
                      {
                        const linkNode = document.createElement('a');
                        linkNode.setAttribute('href', url);
                        linkNode.setAttribute('target', '_blank');
                        parent.replaceChild(linkNode, imgNode);
                        linkNode.appendChild(imgNode);
                      } 
                      else 
                      {
                        parent.setAttribute('href', url);
                      }
                    }
                  }
                }
              }
            }
          },
          imageResize: {                        //반드시 추가!
            parchment: window.Quill
              ? window.Quill.import('parchment')
              : undefined,
            modules: ['Resize', 'DisplaySize', 'Toolbar']  // 필요하다면 Toolbar 포함
          }
        },

        formats: [
          'bold','italic','underline','strike','blockquote','code-block','header','list',
          'script','indent','direction','size','color','background','font','link','image','video',
          'align', 'float', 'width', 'height'
        ]
      },

      thumbFlag: "N",            //썸네일사용여부
      thumbNail: "N",            //썸네일존재여부
      //noticeThumbnail: [],     //공지썸네일정보
    };
  },
    // 로그인된 사용자만 접근가능페이지
  computed: {
    user() {
      return this.$store.state.user;
    }
  },
  created() 
  {
    this.user = this.$store.state.user
    //console.log("USER:",this.user);
  },
  mounted() {
    // if(document.referrer == "") {
    //   this.$swal.fire('', '적절하지 않은 페이지 접근입니다.', 'error');
    //   location.replace("/")
    // }
    //권한없는 로그인 차단
    if(this.user.handlerId == undefined || this.user.handlerGrade >= 20) {
      var swal = require('sweetalert2');
      swal.fire({
        title: '로그인 필요',
        text: '접근권한 확인불가.',
        icon: 'error'
      });
      this.$router.push({path: '/b2bLogin'});
    }
    //document.getElementById("notice").style.display = "none";
    document.getElementById("user").style.display = "none";

    //오늘날짜추출
    const date = new Date(+new Date() + 3240 * 10000).toISOString().split("T")[0]
    const time = new Date().toTimeString().split(" ")[0];
    this.today = date + ' ' + time;
    //let tStamp = "";
    this.tStamp = new Date().getTime();
  },

  methods: {
    //썸네일사용여부 체크
    checkThumb(thFlag) {
      this.thumbFlag = thFlag;
      //console.log("thumbFlag:", this.thumbFlag);
    },

    // Quill Editor관련
    onEditorChange({ html }) {
      this.internalContent = html         // 내부 상태만 변경
      this.$emit('update:content', html)  // 부모에 변경 알림
    },
    saveDoc() {
      const html = this.$refs.quillRef?.$el?.querySelector('.ql-editor')?.innerHTML || this.internalContent 
      this.$emit('saveDocument', { content: html })
      // this.$emit('saveDocument', { content: this.internalContent })
    },

    // Quill Editor결과저장
    async handleSaveDocument(payload) {
      if (!this.ctCd || this.ctCd === '') 
      {
        this.$swal.fire('', '공지카테고리를 선택하세요', 'warning');
        return false;
      }

      if (!this.nTitle || this.nTitle.trim() === '') 
      {
        this.$swal.fire('', '공지제목을 입력하세요', 'warning');
        return false;
      }

      if (!payload.content || payload.content.trim() === '') 
      {
        this.$swal.fire('', '공지내용을 입력하세요', 'warning');
        return false;
      }

      //썸네일 이미지를  jpg로 선택했는지 확인
      let imgFile = document.getElementById('fileSelectorImage').files;
      if (imgFile) 
      {
        let fileLength    = imgFile[0].name.length;
        let fileType_tmp  = imgFile[0].name.lastIndexOf(".");
        let extension     = imgFile[0].name.substring(fileType_tmp + 1, fileLength).toLowerCase();
        let fileType      = imgFile[0].type;

        if (fileType != "image/jpeg" || extension !== "jpg") 
        {
          this.$swal.fire('', '썸네일은 jpg 이미지만 지원합니다.', 'warning');
          return false;
        }
      }

      //console.log("content:", payload.content)
      
      try 
      {
        let noticeCode =  this.ctCd + "-" + this.tStamp;
        //console.log("today: ",this.today, "noticeCode:", noticeCode);

        this.noticeCode = noticeCode;
        // this.nFrom = (this.ctCd === 'EV' || this.ctCd === 'PR') ? (this.nFrom) : null
        // this.nTo   = (this.ctCd === 'EV' || this.ctCd === 'PR') ? (this.nTo) : null
        // this.insDate = this.today;
        this.insId = this.user.handlerId;
        this.nUseFlag = "N";
        this.showFlag = 'Y'
        let filename = `${this.noticeCode}.md`;
        //console.log("filename:", filename);

        // let response = await this.$api(`/uploads/doc_editor/`, { content: payload.content, filename: this.filename });
        let response = await this.$api(`/uploads/notice/${this.ctCd}/`, { content: payload.content, filename: filename });
        if (response.success === true) 
        {
          // 썸네일이 있다면 업로드
          //let imgFile = document.getElementById('fileSelectorImage').files;
          if (imgFile) 
          {
            this.thumbNail = "Y"        //썸네일존재여부
            await this.uploadFile(imgFile, this.ctCd, this.noticeCode, "image");
          }

          //nTitle, nFrom, nTo, nUseFlag, insId, insDate, ctCd, noticeCode, showFlag, fixedFlag, quillFlag
          let res_insertNotice_new = await this.$api("/api/insertNotice_new", {param: 
            [ 
              this.nTitle, this.nFrom, this.nTo, this.nUseFlag, this.insId, this.ctCd, this.noticeCode, this.showFlag, this.fixedFlag, this.quillFlag, this.thumbFlag, this.thumbNail
            ]
          });
          if(res_insertNotice_new.affectedRows > 0) 
          {
            this.$swal.fire('', '공지사항이 저장되었습니다.', 'success');
          }
        } 
        else 
        { 
          this.$swal.fire('', '공지사항 저장 중 오류가 발생했습니다.', 'warning');
        }
      } 
      catch (error) 
      {
        this.$swal.fire('', '문서 저장 중 오류가 발생했습니다.', 'error');
      }
    },

    /** 이미지 or 동영상 사본등록 */
    async uploadFile(file, id, passNo, fileType) {

      let files = ""

      if (file[0].size > 3 * 1024 * 1024) 
      {
        files = await this.compressFile(file[0], fileType)
      }
      else
      {
        files = file[0];
      }
      
      // let fileLength = 0
      // let fileType_tmp = "";
      let licenseFile = "";
      //let uploadedFile = "";
      let data = null;

      if (files) 
      {
        licenseFile = `${passNo}.jpg`;
        data = await this.$base64(files);

        const { error } = await this.$api(`/upload/notice/${id}/${licenseFile}`, { data });

        if (error) 
        {
          return this.$swal("업로드(uploadFile) 오류발생, 재시도 필요.");
        }
      }
    },

    async compressFile(file, fileType) 
    {
      // 이미지 크기한도: 3메가
      if (fileType === "image" && file.size > 3 * 1024 * 1024) 
      //if (fileType === "image" && file.size > 2000000)
      {
        return await this.compressImage(file);
      } 
      // 동영상 크기한도: 20메가
      else if (fileType === "video" && file.size > 20 * 1024 * 1024) 
      {
        this.$swal.fire("","동영상 업로드는 20메가 미만으로 제한됩니다", "warning")
        return false;
      }
      return file; // 크기 초과하지 않으면 원본 파일 반환
    },

    async compressImage(file) {
      const reader = new FileReader();

      return new Promise((resolve, reject) => {
        reader.onload = (event) => {
          const img = new Image();
          img.onload = () => {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");

            const maxDimension = 3200;
            let width = img.width;
            let height = img.height;

            if (width > maxDimension || height > maxDimension) {
              if (width > height) {
                height = Math.round((height * maxDimension) / width);
                width = maxDimension;
              } else {
                width = Math.round((width * maxDimension) / height);
                height = maxDimension;
              }
            }

            canvas.width = width;
            canvas.height = height;
            ctx.drawImage(img, 0, 0, width, height);

            canvas.toBlob(
              (blob) => {
                if (blob.size > 3 * 1024 * 1024) {
                  reject(new Error("이미지를 3MB 이하로 압축할 수 없습니다."));
                } else {
                  resolve(new File([blob], file.name, { type: "image/jpeg" }));
                }
              },
              "image/jpeg",
              1.0 // 품질 설정
            );
          };
          img.src = event.target.result;
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    },

    goToList() {
      this.$router.push({path: '/noticeList'});
    },

    async noticeInsert() 
    {
      //오늘날짜추출
      const date = new Date(+new Date() + 3240 * 10000).toISOString().split("T")[0]
      const time = new Date().toTimeString().split(" ")[0];
      let today = date + ' ' + time;
      let tStamp = "";
      tStamp = new Date().getTime();

      let noticeCode =  this.notice.ctCd + "-" + tStamp;

      if(!this.notice.nTitle) {
        this.$refs.txt_nTitle.focus();
        return this.$swal.fire("필수누락: 공지제목");
      }
      // if((this.notice.ctCd === 'EV' || this.notice.ctCd === 'PR') && !this.notice.nFrom) {
      //   this.$refs.txt_fromDate.focus();
      //   return this.$swal.fire("필수누락: 개시일");
      // }
      // if((this.notice.ctCd === 'EV' || this.notice.ctCd === 'PR') && !this.notice.nTo) {
      //   this.$refs.txt_toDate.focus();
      //   return this.$swal.fire("필수누락: 종료일");
      // }
      // if((this.notice.ctCd === 'EV' || this.notice.ctCd === 'PR') && this.notice.nStart > this.notice.nTo) {
      //   return this.$swal.fire("","행사 시작일과  종료일을 확인해주세요", "warning");
      // }
      this.notice.noticeCode = noticeCode;
      // this.notice.nFrom = (this.notice.ctCd === 'EV' || this.notice.ctCd === 'PR') ? (this.notice.nFrom) : null
      // this.notice.nTo   = (this.notice.ctCd === 'EV' || this.notice.ctCd === 'PR') ? (this.notice.nTo) : null
      this.notice.insDate = today;
      this.notice.insId = this.user.handlerId;
      this.notice.nUseFlag = "N";

      // 동영상 업로드 처리
      if (this.activeUpload === "video") {
        let videoFile = document.getElementById('fileSelectorVideo').files;
        
        if (videoFile && videoFile[0].size > 20 * 1024 * 1024 ) 
        {
          this.$swal.fire("","동영상 업로드는 20메가 이하로 제한됩니다", "warning")
          return false;
        }
      }

      let resIns_notice = await this.$api("/api/noticeInsert", {param: [this.notice]});
      if(Object.keys(resIns_notice)[0] === 'error') 
      {
        this.$swal.fire('','저장실패', 'error')
      }
      else
      {
        // 이미지 업로드 처리
        if (this.activeUpload === "image") {
          const imgFile = document.getElementById('fileSelectorImage').files;
          if (imgFile.length > 0) 
          {
            await this.uploadFile(imgFile, this.notice.ctCd, this.notice.noticeCode, "image");
          }
        }

        // 동영상 업로드 처리
        if (this.activeUpload === "video") {
          const videoFile = document.getElementById('fileSelectorVideo').files;
          if (videoFile.length > 0) 
          {
            await this.uploadFile(videoFile, this.notice.ctCd, this.notice.noticeCode, "video");
          }
        }

        this.$swal.fire('','저장완료', 'success');
        this.$router.push({path: '/noticeList'});

        // else
        // {
        //   this.$swal.fire('','저장완료', 'success');
        //   this.$router.push({path: '/noticeList'});
        // }
      }
    },
  }
}
</script>

<style scoped>
  label {
    font-weight: bold;
    font-size: 1.1rem;
  }
</style>

<!-- <style>
.ql-editor .ql-align-right { text-align: right !important; }
.ql-editor .ql-align-center { text-align: center !important; }
.ql-editor .ql-align-left { text-align: left !important; }
.ql-editor .ql-align-justify { text-align: justify !important; }

.ql-editor .ql-align-right img,
.ql-editor .ql-align-center img,
.ql-editor .ql-align-left img {
  display: block !important;
}

.ql-editor .ql-align-right img { margin-left: auto !important; margin-right: 0 !important; }
.ql-editor .ql-align-center img { margin-left: auto !important; margin-right: auto !important; }
.ql-editor .ql-align-left img { margin-left: 0 !important; margin-right: auto !important; }
</style> -->